import React from 'react';

import AuthLegalDisclosure from '../../../../../../components/auth/AuthLegalDisclosure';

const SupportText = () => {
  return (
    <AuthLegalDisclosure
      className="mt-4"
      showSmsConsent
      smsCtaLabel="Send PIN Code to Verify"
    />
  );
};

export default SupportText;
